import { useAxios } from '../utils/axiosConfig';
import { useNotification } from "../contexts/NotificationContext";
import config from '../contexts/ConfigContext';
interface DocumentStatusModel {
    Description: string;
    Id: number;
}

class DocumentService {
    axios = useAxios();
    notification = useNotification();
    async GetDocumentStatus(): Promise<DocumentStatusModel[]> {
        try {
            const response = await this.axios.get(`${config.API_LABELING_URL}/api/Documents/GetStatuses`);
            return response.data;
        } catch (error) {
            this.notification.showNotification('Error fetching document status', 'error');
            console.error('Error fetching documents:', error);
            return [];
        }
    }
}
export default DocumentService;